import { ICellRendererParams } from "ag-grid-community";
import _ from "lodash";
import { TenantService } from "projects/shared/src/lib/services/tenant.service";
import { TranslateService } from "projects/shared/src/lib/services/translate.service";


export class AgGridTenantsSettings {

    constructor(private translate: TranslateService, private tenantService: TenantService) {}

    public agGridUsersSettings = {
        rowModelType: 'infinite',
        //virtualPaging: true,
        //enableServerSideSorting: true,
        //enableServerSideFilter: true,
        rowSelection: 'single',
        //rowDeselection: true,
        rowHeight: 45,
        enableRangeSelection: true,
        cacheBlockSize: 10000,
        cacheOverflowSize: 2,
        maxConcurrentDatasourceRequests: 1,
        paginationPageSize: 30,
        infiniteInitialRowCount: 0,
        columnDefs: [
          { field: 'displayName', headerName: `${this.translate.data["DISPLAYNAME"]}`, sortable: true, filter: true },
          {
            headerName: `${this.translate.data["TENANTSACTIONSCOLUMNHEADER"]}`,
            cellRenderer: 'buttonRenderer',
            cellRendererParams: {
              icon_edit: 'edit',
              icon_delete: 'delete',
              // routerLinkEditTenant: (params: ICellRendererParams) => `/manage-tenants/${_.get(params, 'data.id')}/edit`
              routerLinkEditTenant: (params: ICellRendererParams) => `/${this.tenantService.currentTenantName}/manage-tenants/${_.get(params, 'data.id')}`
            },
          },
        ],
        defaultColDef: {
          flex: 1,
          resizable: true,
          minWidth: 100,
          editable: false
        }
      }
}